// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3sg0c","errorLogs":"EditorFooter_errorLogs__Wmxv4"};